<template>
  <div class="main-div">
    <span
      v-if="sources.length > 0 && idx < 3"
      v-for="(fileObj, idx) in sources"
      :key="idx"
    >
      <img
        @click="downloadFile(fileObj.link)"
        class="small-image"
        @mouseleave="show = null"
        @mouseenter="show = idx"
        :src="fileObj.src"
        alt=""
        v-if="
          fileObj.type.ext != 'pdf' &&
            fileObj.type.ext != 'doc' &&
            fileObj.type.ext != 'xlsx'
        "
      />
      <i
        @click="downloadFile(fileObj.link)"
        v-else
        @mouseleave="show = null"
        @mouseenter="show = idx"
        :class="fileObj.type.class"
      ></i>
      <div
        class="image-div"
        v-if="
          fileObj.type.ext != 'pdf' &&
            fileObj.type.ext != 'doc' &&
            fileObj.type.ext != 'xlsx'
        "
      >
        <img
          @mouseleave="show = null"
          :class="show != idx ? 'd-none' : 'big-image'"
          :src="fileObj.src"
          alt=""
        />
      </div>
      <div v-else>
        <div
          @mouseleave="show = null"
          :class="show != idx ? 'd-none' : 'file-title'"
        >
          {{ fileObj.src }}
        </div>
      </div>
    </span>
  </div>
</template>
<!--TODO-->
<!--  *filter-->
<script>
export default {
  name: "TaskAttachmentTd",
  props: {
    task: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      sources: "",
      show: null
    };
  },
  mounted() {
    this.getSrcFromContent();
  },
  methods: {
    downloadFile(src) {
      window.open(src, "_blank");
    },
    getSrcFromContent() {
      //START get clean images and iframes src
      let splitedString = this.task.content.split("<");
      let files = splitedString
        .filter(i => i.startsWith("img"))
        .concat(splitedString.filter(i => i.startsWith("iframe")));
      let sources = [];
      files.map(src => {
        src = src.split('src="');
        let re = /(?:\.([^.]+))?$/;
        src = src[1].split('"')[0];
        let type = re.exec(src)[1];
        let link = re.exec(src)["input"].split(re.exec(src)[0]);
        link = link[0] + "." + type.split("&")[0];
        switch (type.split("&")[0]) {
          case "pdf":
            type = {
              class: "fas fa-file-pdf fa-lg",
              ext: "pdf"
            };
            break;
          case "doc":
            type = {
              class: "fas fa-file fa-lg",
              ext: "doc"
            };
            break;
          case "xlsx":
            type = {
              class: "fas fa-file-excel fa-lg",
              ext: "xlsx"
            };
            break;
          default:
            type = {
              ext: "img"
            };
        }
        sources.push({
          src: src,
          link: link,
          type: type
        });
      });
      //END get clean images and iframes src
      this.sources = sources;
    }
  }
};
</script>

<style scoped>
.file-title {
  background: black;
  color: white;
  border-radius: 10px;
  font-size: 1rem;
  padding: 7px;
  overflow: hidden;
  width: 360px;
  position: absolute;
  z-index: 1;
}
.main-div {
  width: 60px;
  display: flex;
}
.fa-file {
  color: grey;
}
.fa-file-excel {
  color: green;
}
.fa-file-pdf {
  color: #b31313;
}
.small-image {
  width: 18px;
  height: 20px;
  cursor: pointer;
  position: relative;
  top: -3px;
  margin-right: 1px;
}
.fas {
  margin-right: 1px;
  cursor: pointer;
}
.image-div {
  display: inline;
}
.d-none {
  display: none;
}
.big-image {
  width: 275px;
  position: absolute;
  z-index: 1;
  border-radius: 5px;
}
img{
  border: 1px solid #d0d0d0;
  border-radius: 1px;
}
</style>
